// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4f36ccb6","513":"707b7a70","703":"68e901e0","787":"230a9e0f"}[chunkId] + ".chunk.js";
};